module.exports = __webpack_public_path__ + "img/vector_210-252_41-256.f6985c0e.png";